import './FeedbackCheckbox.scss'

import React, { Component } from 'react'

export default class FeedbackCheckbox extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { label, checked, value, onChange, errorMsg, disabled, labelClass } = this.props

    return (
      <div className="FeedbackCheckbox">
        <label className={labelClass ? "FeedbackCheckbox__label " + labelClass : "FeedbackCheckbox__label"}><div className={errorMsg ? "FeedbackCheckbox__input__wrapper--error" : "FeedbackCheckbox__input__wrapper"}>
            <input
            type="checkbox"
            checked={checked}
            value={value}
            onChange={(e) => onChange(e)}
            className="form-control"
            disabled={disabled}
          />
        </div>{label}</label>
        <div className="FeedbackCheckbox__error">
          {errorMsg ? (<span className="FeedbackCheckbox__error--message">{errorMsg}</span>) : null}
        </div>
      </div>
    )
  }

}
